
























import { Component, Vue } from 'vue-property-decorator';
import { currencyService } from '@/services/CurrencyService';

@Component({
  props: ['price', 'currency', 'period', 'fractionNumber'],
})
export default class PriceWithCurrency extends Vue {
  defaultCurrency = '';
  language = '';
  fixCurrency(currency: string) {
    if (currency === 'PLN') {
      return 'zł';
    }
    if (currency === 'USD') {
      return '$';
    }
    if (currency === 'EUR') {
      return '€';
    }
    return currency;
  }
  fixPrice(price: any, fractionNumber: any = null) {
    price = typeof price !== 'number' ? parseFloat(price) : price;
    let precision = 1 - Math.floor(Math.log(Math.abs(price)) / Math.log(10));
    precision = price > 1 ? 2 : precision;
    const fraction = fractionNumber === null ? (precision < 2 ? 2 : precision) : fractionNumber;
    return price ? price.toFixed(fraction) : 0;
  }
  langFormat(price: any) {
    if (this.$root.$i18n.locale === 'pl') {
      return price.toString().replace('.', ',');
    } else {
      return price;
    }
  }
  mounted() {
    const workspaceId = parseInt(this.$route.params.workspaceId, 10);
    currencyService.getCurrency(workspaceId).then((currency: string) => {
      this.defaultCurrency = currency;
    });
  }
}
